import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'; // ⭐ AJOUTER

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCVAJa90ImKl9kgYeqEDBenXEi-wmymK5I',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'medaviceia.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'medaviceia',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'medaviceia.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '464294192206',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:464294192206:web:2e353832bee6a9bfcb0f1f',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1'); // ✅

export default app;
